const BooleanSwitchResponseText = {
  YES: 'Yes',
  NO: 'No',
  NOT_PROVIDED: '(not provided)',
};

const BooleanSwitchRuleValue = {
  EITHER: 'either',
  NO: 'No',
  YES: 'Yes',
};

const BooleanSwitchResponseValue = {
  NOT_PROVIDED: null,
  YES: true,
  NO: false,
};

const BooleanSwitchResponseValueList = Object.values(BooleanSwitchResponseValue);

const BooleanSwitchResponseValueMap = {
  [BooleanSwitchResponseValue.YES]: BooleanSwitchResponseText.YES,
  [BooleanSwitchResponseValue.NO]: BooleanSwitchResponseText.NO,
  [BooleanSwitchResponseValue.NOT_PROVIDED]: BooleanSwitchResponseText.NOT_PROVIDED,
};

export const BooleanSwitchRuleValueMap = {
  [BooleanSwitchRuleValue.NO]: [false],
  [BooleanSwitchRuleValue.YES]: [true],
  [BooleanSwitchRuleValue.EITHER]: [false, true],
};

export default {
  RESPONSE_TEXT: BooleanSwitchResponseText,
  RESPONSE_VALUE: BooleanSwitchResponseValue,
  RESPONSE_VALUE_MAP: BooleanSwitchResponseValueMap,
  RESPONSE_VALUE_LIST: BooleanSwitchResponseValueList,
  RULE_VALUE: BooleanSwitchRuleValue,
  RULE_VALUE_MAP: BooleanSwitchRuleValueMap,
};
